module.exports = __webpack_public_path__ + "img/D202308_2.26ae40ff.jpg";